export const disableCorePrefetching = () => true;
